var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql } from '@apollo/client/core';
import { CONNECTION_METADATA_FIELDS } from '../connection/Api';
import * as GqlConnection from '../connection/GqlConnection';
import * as TicketLayout from './TicketLayout';
const TICKET_LAYOUT_FIELDS = gql `
  fragment TicketLayoutFields on TicketLayout {
    id
    name
    fglString
    layout
    default
  }
`;
const TICKET_LAYOUT_QUERY = gql `
  query TicketLayout($id: Int!) {
    app {
      ticketLayout(id: $id) {
        ...TicketLayoutFields
      }
    }
  }
  ${TICKET_LAYOUT_FIELDS}
`;
const TICKET_LAYOUTS_QUERY = gql `
  query Layouts($after: String, $before: String, $first: Int) {
    app {
      ticketLayouts(after: $after, before: $before, first: $first) {
        edges {
          cursor
          node {
            ...TicketLayoutFields
          }
        }
        pageInfo {
          ...ConnectionMetadataFields
        }
      }
    }
  }
  ${CONNECTION_METADATA_FIELDS}
  ${TICKET_LAYOUT_FIELDS}
`;
export const fetchLayouts = (client_1, _a) => __awaiter(void 0, [client_1, _a], void 0, function* (client, { after, first }) {
    const { data } = yield client.query({
        query: TICKET_LAYOUTS_QUERY,
        variables: {
            after,
            first,
        },
    });
    return GqlConnection.fromGql(data.app.ticketLayouts, TicketLayout.fromGQL);
});
export const fetchLayout = (client, id) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.query({
        query: TICKET_LAYOUT_QUERY,
        variables: { id },
    });
    if (!data.app.ticketLayout) {
        return undefined;
    }
    return TicketLayout.fromGQL(data.app.ticketLayout);
});
const SAVE_TICKET_LAYOUT_MUTATION = gql `
  mutation SaveTicketLayout($ticketLayout: TicketLayoutAttributes!) {
    app {
      saveTicketLayout(input: { ticketLayout: $ticketLayout }) {
        ticketLayout {
          ...TicketLayoutFields
        }
        errors
      }
    }
  }
  ${TICKET_LAYOUT_FIELDS}
`;
export const saveTicketLayout = (client, layout) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.mutate({
        mutation: SAVE_TICKET_LAYOUT_MUTATION,
        variables: {
            ticketLayout: layout,
        },
    });
    client.cache.evict({ id: `TicketLayout:${layout.id}` });
    client.cache.gc();
    if (data.app.saveTicketLayout.errors) {
        return {
            success: false,
            errors: data.app.saveTicketLayout.errors,
        };
    }
    return {
        success: true,
        data: data.app.saveTicketLayout.ticketLayout && TicketLayout.fromGQL(data.app.saveTicketLayout.ticketLayout),
    };
});
//# sourceMappingURL=Api.js.map